import { Transform } from 'class-transformer';
import { IsString, IsNotEmpty, IsIn } from 'class-validator';
import sanitize from 'sanitize-filename';
import { ImageDestinationArray, ImageDestinationEnum } from '../../enums';

export class CompressImageDto {
	@Transform(({ value }) => (typeof value === 'string' ? sanitize(value) : null))
	@IsNotEmpty()
	@IsString()
	imageId: string;

	@IsIn(ImageDestinationArray) destination: ImageDestinationEnum;
}
